import { Injectable } from '@angular/core';
import { CompanyActions } from '@company/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { AuthActions } from '@spartacus/core';
import { CustomUserActions, CustomUserSelectors, StateWithCustomUser } from '@user/data-access';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class LegalEntityStatusEffects {
  setLegalEntityStatusWhenSelectCompany$: Observable<CustomUserActions.SetLegalEntityStatus> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.SelectCompany>(CompanyActions.SELECT_COMPANY),
      filter(({ payload }) => Boolean(payload)),
      concatLatestFrom(() => this.store.select(CustomUserSelectors.getLegalEntityStatus)),
      filter(([, isLegal]) => !isLegal),
      map(() => new CustomUserActions.SetLegalEntityStatus(true)),
    ),
  );

  setLegalEntityStatusWhenResetCompany$: Observable<CustomUserActions.SetLegalEntityStatus> = createEffect(() =>
    this.actions$.pipe(
      ofType<CompanyActions.ResetSelectedCompany>(CompanyActions.RESET_SELECTED_COMPANY),
      concatLatestFrom(() => this.store.select(CustomUserSelectors.getLegalEntityStatus)),
      filter(([, isLegal]) => Boolean(isLegal)),
      map(() => new CustomUserActions.SetLegalEntityStatus(false)),
    ),
  );

  setLegalEntityStatusAfterLogout$: Observable<CustomUserActions.SetLegalEntityStatus> = createEffect(() =>
    this.actions$.pipe(
      ofType<AuthActions.Logout>(AuthActions.LOGOUT),
      concatLatestFrom(() => this.store.select(CustomUserSelectors.getLegalEntityStatus)),
      filter(([, isLegal]) => Boolean(isLegal)),
      map(() => new CustomUserActions.SetLegalEntityStatus(false)),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<StateWithCustomUser>,
  ) {}
}
